import React from 'react';
import Header from '../components/Header/Header';
import Services from "../components/Services/Services";
import Footer from '../components/Footer/Footer';


function Landingpage() {
  return (
    <div>
    <Header/>
    <Services />
    <Footer/>
    </div>
  )
}

export default Landingpage